import React, { useState } from 'react'
import TopMenu from './TopMenu'
import NavbarMenu from './NavbarMenu'
import Footer from './Footer'
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { Col, Row, Label, Input, Button } from 'reactstrap';
import axios from 'axios'
import Swal from 'sweetalert2';
import ReCAPTCHA from "react-google-recaptcha";


function Contact() {
    const [contactData, setContactData] = useState({ name: '', email: '', phone: '', message: '', info_data: '' })
    const onChange = () => {
        console.log()
    }
    const handalSubmit = async () => {
        if (contactData.name === '' || contactData.phone === '' || contactData.email === '' || contactData.message === '') {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "All fields are mandatory",
                footer: ''
            });
            return
        }
        const res = await axios.post(`https://ngt.botberries.com/smartcard/contact-us-add`, contactData)
        Swal.fire({
            title: "Thank you for contacting us!",
            icon: "success",
            draggable: true
          });
          setContactData({ name: '', email: '', phone: '', message: '', info_data: '' })

    }
    return (
        <div>
            <TopMenu />
            <NavbarMenu />
            <div className='bg-about'>
                <div className='container pt-5 about-a'>
                    <h2 className='text-light'>Contact us</h2>
                    <p className='text-light'>Home / Contact us</p>
                </div>
            </div>
            <div>
                <div className='container pt-5 pb-5'>
                    <div className='row'>
                        <div className='col-sm-4'>
                            <div className='contact-info'>
                                <h4>Contact info</h4>
                                <p >
                                    <FaMapMarkerAlt /> {' '}
                                    <span className='text-team'>
                                        300 Wilmington Ave, suite 210. Wilmington De USA 19801 

                                        <br /><br />
                                        <FaMapMarkerAlt /> {' '}
                                        2nd Floor, 2572 Daniel-Johnson Boulevard, Laval, Quebec H7T 2R3, Canada
                                    </span>
                                </p>
                                <p><FaPhoneAlt /> {' '} +1-844-THE-PAYMENT Intl </p>
                                <p><FaPhoneAlt /> {' '}  +1-718-717-8657 (USA) </p>
                                <p><FaPhoneAlt /> {' '} +1-514-504-2126 (Canada) </p>
                                <p><FaPhoneAlt /> {' '} +34 626267795 (EU - Madrid) </p>
                            </div>
                        </div>
                        <div className='col-sm-8'>
                            <div className='contact-form'>
                                <h4 className='text-center'>Get in touch</h4>
                                {/* row-cols-lg-auto g-3 align-items-center */}
                                <Row className="">
                                    <Col sm={6}>
                                        <Label>
                                            Name
                                        </Label>
                                        <Input
                                            type='text' placeholder='Full name'
                                            value={contactData.name}
                                            onChange={(e) => { setContactData((prev) => ({ ...prev, name: e.target.value })) }}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Email
                                        </Label>
                                        <Input
                                            type='text' placeholder='Email'
                                            value={contactData.email}
                                            onChange={(e) => { setContactData((prev) => ({ ...prev, email: e.target.value })) }}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label>
                                            Phone
                                        </Label>
                                        <Input
                                            type='text' placeholder='Phone number'
                                            value={contactData.phone}
                                            onChange={(e) => { setContactData((prev) => ({ ...prev, phone: e.target.value })) }}
                                        />
                                    </Col>
                                    <Col sm={12}>
                                        <Label>
                                            Message
                                        </Label>
                                        <Input
                                            type='textarea' placeholder='Message'
                                            value={contactData.message}
                                            onChange={(e) => { setContactData((prev) => ({ ...prev, message: e.target.value })) }}
                                        />
                                    </Col>
                                    <Col sm={12} className='pt-5'>
                                        <ReCAPTCHA
                                                sitekey="6Ldp47MsAAAAAJLp3K6lwciznGbRByEu36n062fb"
                                                onChange={onChange}
                                            />
                                    </Col>
                                    <Col sm={12} className='pt-5'>
                                        <Button type='button' block color='primary'
                                            onClick={handalSubmit}
                                        >Submit</Button>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </div>
                    <div className='row pt-5'>
                        <div className='col-sm-6'>
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2425.51006001549!2d-75.5448510251341!3d39.72056189771801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c702a42dbce3af%3A0x7fffc4e667212fa0!2s300%20Wilmington%20Ave%2C%20New%20Castle%2C%20DE%2019720%2C%20USA!5e1!3m2!1sen!2sin!4v1793097883320!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe> */}
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2425.51006001549!2d-75.5448510251341!3d39.72056189771801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c702a42dbce3af%3A0x7fffc4e667212fa0!2s300%20Wilmington%20Ave%2C%20New%20Castle%2C%20DE%2019720%2C%20USA!5e1!3m2!1sen!2sin!4v1793097883320!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <div className='col-sm-6'>
                            <iframe src="https://www.google.com/maps?q=2572+Daniel-Johnson+Boulevard%2C+Laval%2C+Quebec+H7T+2R3%2C+Canada&output=embed" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Contact